import { Grid, Box, MenuItem, Card, CardContent } from '@mui/material';
import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { useNavigate } from 'react-router-dom';
import Backdrop from '@mui/material/Backdrop';

import ApiService from '../../../../services/ApiService';
import ButtonUnprintedInvoiceView from './Buttons/ButtonUnprintedInvoiceView';
import LoadingSpinner from '../../../../components/Components/LoadingSpinner';
import ModalConfirmation from '../../../../components/Modals/ModalConfirmation';
import HeaderInfo from '../../../../components/Components/HeaderInfo';
import CustomToastContainer, { CustomDatePicker, Selection, showToast } from '../../../../components/ui';
import { PrintExcel, PrintPDF } from '../../../../utils/reusableFunction';

const UnprintedInvoiceView = forwardRef((props, ref) => {
    const [isLoadingBackDrop, setIsLoadingBackDrop] = useState(true);
    const history = useNavigate();
    const paramRegUserAccess = 'regUserAccess/regUserAccess';
    const [DataRegUserAccess, setDataRegUserAccess] = useState([]);

    const printTypeList = [
        { id: 1, code: 'ALL', name: 'All' },
        { id: 2, code: 'NONDELETED', name: 'Non-Deleted' },
        { id: 3, code: 'NONCANCEL', name: 'Non-Cancel' },
        { id: 4, code: 'NONDELETECANCEL', name: 'Non-Deleted & Non-Cancel' },
    ]
    const [PrintingType, setPrintingType] = useState('ALL');

    const [PeriodFrom, setPeriodFrom] = useState('');
    const [PeriodTo, setPeriodTo] = useState('');

    const [isModalConfirmation, setIsModalConfirmation] = useState(false);
    const [titleModalConfirmation, setTitleModalConfirmation] = useState('');
    const [titleConfirmation, setTitleConfirmation] = useState('');

    const BreadcrumbsItems = [
        { label: 'Majura', link: '/Majura', style: '' },
        { label: 'Unprinted Invoice Report', link: '/Majura/UnprintedInvoiceReport', style: { color: '#0087C2', fontWeight: '700' } },
    ];

    useImperativeHandle(ref, () => ({
        localSave() {

        }
    }));

    useEffect(() => {
        document.title = 'Unprinted Invoice Report - ' + JSON.parse(localStorage.getItem('branchName'));
        getDataAccess();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const selectPrintingType = (PrintingType, setPrintingType) => {
        return (
            <Selection
                id='0'
                label={'Type'}
                fullWidth={true}
                placeholder={'Select Type'}
                value={PrintingType}
                onChange={(e) => handleSelectPrintingType(setPrintingType, e.target.value)}
            >
                {
                    printTypeList.map((data) => (
                        <MenuItem sx={{ fontSize: '12px' }} id={data.id} key={data.id} value={data.code}>
                            {data.name}
                        </MenuItem>
                    ))
                }
            </Selection>
        )
    }

    function handleSelectPrintingType(setPrintingType, value) {
        setPrintingType(value);
    }

    function getDateNow() {
        setIsLoadingBackDrop(false);
        const currentDate = new Date();
        const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        var formattedDateFirst = firstDay.toLocaleDateString("sv-se").split('T')[0];
        setPeriodFrom(formattedDateFirst);

        let dateNow = new Date()
        var formattedDateNow = dateNow.toLocaleDateString("sv-se").split('T')[0];
        setPeriodTo(formattedDateNow);
    }

    function handlePeriodFrom(value) {
        if (PeriodTo < value) {
            showToast({ type: 'error', message: 'Period From Can\'t be Greater Than Period To' });
        }
        else {
            setPeriodFrom(value);
        }
    }

    function handlePeriodTo(value) {
        if (PeriodFrom > value) {
            showToast({ type: 'error', message: 'Period To Can\'t be Smaller Than Period From' });
        }
        else {
            setPeriodTo(value);
        }
    }

    const getDataAccess = () => {
        setIsLoadingBackDrop(true);
        let params = [];
        let pId = 0;
        let listMenu = JSON.parse(localStorage.getItem("dataMenuCode")) || [];
        let hasAccess = false

        const indexMenu = listMenu.findIndex((elm) => elm.code === 'OSHOR')
        if (indexMenu !== -1) {
            pId = listMenu[indexMenu].id
            hasAccess = true
        }

        if (hasAccess) {
            params = [
                ...params,
                { 'attr': 'permissionId', 'value': '' + pId },
                { 'attr': 'userId', 'value': '' + JSON.parse(localStorage.getItem("userId")) },
                { 'attr': 'roleId', 'value': '' + JSON.parse(localStorage.getItem("roleId")) }
            ]
            ApiService.IdentityPostByPage(paramRegUserAccess, 'PAGE', 1, 100, params, [])
                .then((response) => {
                    if (response.data.code === 200) {
                        setDataRegUserAccess(response.data.data.userAccess);

                        getDateNow();
                    }
                })
                .catch(function (error) {
                    console.error('error saat fetch', error)
                    history('/Majura');
                })
        }
        else {
            history('/Majura');
        }
    }

    const handleClickConfirmation = () => {
        if (isModalConfirmation === false) {
            setIsModalConfirmation(true);
        }
        else {
            setIsModalConfirmation(false);
        }
    }

    function ConfirmationCM() {
        if (titleConfirmation === 'Print PDF' || titleConfirmation === 'Print Excel') {
            setIsLoadingBackDrop(true);

            const reportType = titleConfirmation === 'Print PDF' ? 'pdf' : 'xls';
            const variable = `PrintUnprintedInvoice?invoiceType=${PrintingType}&from=${PeriodFrom}&to=${PeriodTo}&typeReport=${reportType}`;
            const reportLink = `Reports/Operation/Print/UnPrintedInvoiceReport/UnPrintedInvoiceReport/${variable}`;

            const printFunction = titleConfirmation === 'Print PDF' ? PrintPDF : PrintExcel;
            printFunction(setIsLoadingBackDrop, 'Unprinted Invoice', reportLink);
        }
        setIsModalConfirmation(false);
    }

    const PrintData = () => {
        setTitleConfirmation('Print PDF')
        setTitleModalConfirmation('Unprinted Invoice Report');
        handleClickConfirmation();
    };

    const PrintDataExcel = () => {
        setTitleConfirmation('Print Excel')
        setTitleModalConfirmation('Unprinted Invoice Report');
        handleClickConfirmation();
    }

    const ButtonComponents = () => {
        return (
            <ButtonUnprintedInvoiceView
                PrintData={PrintData}
                PrintExcel={PrintDataExcel}
                DataRegUserAccess={DataRegUserAccess}
            />
        )
    }

    return (
        <Box className='w-100' sx={{ width: '100%', p: 3 }}>
            <CustomToastContainer />
            <Grid container spacing={0} direction="column">
                <HeaderInfo
                    title={'Unprinted Invoice Report'}
                    isJobType={false}
                    BreadcrumbsItems={BreadcrumbsItems}
                    ButtonComponents={ButtonComponents}
                />

                <Grid item xs={12} style={{ 'width': '100%', 'borderRadius': '5px' }}>
                    <div className="mt-3">
                        <Grid
                            container
                            spacing={'32px'}
                        >
                            <Grid
                                item
                                xl={6}
                                lg={6}
                                sm={6}
                                xs={12}
                            >
                                <Card component="div" style={{ borderRadius: '12px', backgroundColor: '#F2F2F2', padding: '16px 24px' }}>
                                    <CardContent>
                                        <Grid
                                            container
                                            spacing={'16px'}
                                        >
                                            <Grid
                                                item
                                                xl={6}
                                                lg={6}
                                                sm={6}
                                                xs={12}
                                            >
                                                <CustomDatePicker
                                                    label='Periode From'
                                                    value={PeriodFrom}
                                                    onChange={handlePeriodFrom}
                                                    type={'date'}
                                                    formControlProps={{
                                                        sx: {
                                                            width: '100%',
                                                        }
                                                    }}
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                xl={6}
                                                lg={6}
                                                sm={6}
                                                xs={12}
                                            >
                                                <CustomDatePicker
                                                    label='Periode To'
                                                    value={PeriodTo}
                                                    onChange={handlePeriodTo}
                                                    type={'date'}
                                                    formControlProps={{
                                                        sx: {
                                                            width: '100%',
                                                        }
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid
                                            container
                                            spacing={'16px'}
                                        >
                                            <Grid
                                                item
                                                xl={12}
                                                lg={12}
                                                sm={12}
                                                xs={12}
                                            >
                                                <div style={{ marginTop: '16px' }}>
                                                    {
                                                        selectPrintingType(PrintingType, setPrintingType)
                                                    }
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </div>
                </Grid>
            </Grid>

            {
                isModalConfirmation && (
                    <ModalConfirmation
                        isModal={isModalConfirmation}
                        titleModal={titleModalConfirmation}
                        title={titleConfirmation}
                        handleClick={handleClickConfirmation}
                        ConfirmationData={ConfirmationCM}
                    />
                )
            }

            {
                isLoadingBackDrop && (
                    <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={isLoadingBackDrop}
                    >
                        <LoadingSpinner />
                    </Backdrop>
                )
            }
        </Box>
    )
})

export default UnprintedInvoiceView